<template>
    <div class="px-2 py-4 xl:px-10">
        <div class="max-w-4xl mx-auto w-full space-y-6">
            <div class="flex items-center justify-between">
                <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
                    Create Question
                </h1>
                <router-link
                    to="/question-banks"
                    class="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300"
                >
                    ← Back to Questions
                </router-link>
            </div>

            <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
                <QuestionBankForm
                    :is-editing="false"
                    @saved="handleSaved"
                    @cancel="handleCancel"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import QuestionBankForm from "@/modules/question-banks/components/QuestionBankForm.vue";
import NotificationService from "@/utils/notifications";

const router = useRouter();

const handleSaved = () => {
    NotificationService.success("Question created successfully!");
    router.push("/question-banks");
};

const handleCancel = () => {
    router.push("/question-banks");
};
</script>
